import { SearchApi } from 'legacy/lut/classes/services/api/SearchApi'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { requestMorePartners } from '../api'
import { getPartnerCodes } from '../helpers/getPartnerCodes'
import { updatePartnersDataWithProgramCodes, updateSearchResults } from '../partnerSearchSlice'
import { selectPartnersDataState } from '../selectors'

listenerMiddleware.startListening({
  predicate: (action) => {
    return requestMorePartners.fulfilled.match(action) || updateSearchResults.match(action)
  },
  effect: async (_, { getState, dispatch }) => {
    const state = getState()
    const partners = selectPartnersDataState(state)
    const ids = partners.data
      .map((it) => it.locator.partnerID)
      .filter((id): id is string => Boolean(id))

    const programCodes = await SearchApi.fetchProgramCodes(
      ids,
      0,
      1000 /*100*/,
      undefined,
      undefined,
      undefined /*filter*/
    )

    const partnersWithProgramCodes = partners.data.map((partner) => {
      const codes = programCodes.items
        .filter((i) => i['PARTNER_ID'] === partner.locator.partnerID)
        .map((i: any) => i['Code'])

      return {
        ...partner,
        programCodes: getPartnerCodes(codes),
      }
    })

    dispatch(updatePartnersDataWithProgramCodes(partnersWithProgramCodes))
  },
})
